<div class="file-upload-container">
  <div
    class="upload-area"
    [class.drag-over]="dragOver"
    [class.disabled]="disabled"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <input
      type="file"
      [accept]="accept"
      [multiple]="multiple"
      [disabled]="disabled"
      (change)="onFileSelected($event)"
      class="file-input"
      #fileInput>
    
    <div class="upload-content" (click)="fileInput.click()">
      <mat-icon>cloud_upload</mat-icon>
      <p>Drag and drop files here or click to browse</p>
      <p class="hint">Accepted: {{ accept }} | Max size: {{ maxSize / 1048576 }}MB</p>
    </div>
  </div>

  <div *ngIf="selectedFiles.length > 0" class="file-list">
    <div *ngFor="let file of selectedFiles; let i = index" class="file-item">
      <mat-icon>description</mat-icon>
      <span class="file-name">{{ file.name }}</span>
      <span class="file-size">{{ formatFileSize(file.size) }}</span>
      <button mat-icon-button (click)="removeFile(i)" color="warn">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>

